import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfter() {
  return <Section tone="cream" wide data-id="element-67" data-mp="26k9xmja7pdch">
      <SectionHeading kicker="From “I know how to do nails”…" data-id="element-68" data-mp="22l14ngmzxjhz">
        To “I have a <em className="text-berry" data-id="element-69" data-mp="22iy5a5zyee0l">professional system</em> for teaching them.”
      </SectionHeading>

      <div className="mx-auto mt-8 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-muted" data-id="element-70" data-mp="2z8nvmz1aw9o1">
        <p data-id="element-71" data-mp="2qabva5amtxie">You already know your craft. You know how to create beautiful nails. You know your techniques.</p>
        <p className="font-serif text-[22px] font-bold text-ink" data-id="element-72" data-mp="2lbir53h8jiuw">But teaching is different.</p>
        <p data-id="element-73" data-mp="1eux1tbhmtns1">
          Knowing how to perform a technique doesn't automatically give you a professional curriculum, student workbook,
          evaluation system or polished classroom experience. That's where Nail Course In A Box™ comes in.
        </p>
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-74" data-mp="1765p6swruivx">
        <div className="rounded-3xl border border-petal bg-white p-6 md:p-8" data-id="element-75" data-mp="1c4pacr3jjqn8">
          <div className="flex items-center gap-3" data-id="element-76" data-mp="y4xyavwl4kbv">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#FDE2E2] text-[#C0392B]" data-id="element-77" data-mp="y4ehjiio81zf">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-78" data-mp="135vg37donccu" />
            </span>
            <h3 className="text-[15px] font-extrabold uppercase tracking-[0.12em] text-[#B03A2E]" data-id="element-79" data-mp="odbdq8ycx8wg">Before</h3>
          </div>
          <ul className="mt-5 space-y-4" data-id="element-80" data-mp="t7fq57qe694x">
            {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-muted" data-id="element-81" data-mp="fc3iy0v1uq74">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#C0392B]" aria-hidden="true" data-id="element-82" data-mp="jdp409hqmase" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl bg-berry p-6 text-white shadow-[0_20px_40px_-20px_rgba(163,51,90,0.7)] md:p-8" data-id="element-83" data-mp="aek6n6hwwnht">
          <div className="flex items-center gap-3" data-id="element-84" data-mp="2c6dm3r88p4u9">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-cta" data-id="element-85" data-mp="27dao96wfj989">
              <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-86" data-mp="23d0km0w40uwk" />
            </span>
            <h3 className="text-[15px] font-extrabold uppercase tracking-[0.12em]" data-id="element-87" data-mp="1ydxf6fc7wmo2">With Nail Course In A Box™</h3>
          </div>
          <ul className="mt-5 space-y-4" data-id="element-88" data-mp="2v2c2jary1elg">
            {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-medium leading-snug" data-id="element-89" data-mp="2r2utk7db5zbj">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-petal" strokeWidth={3} aria-hidden="true" data-id="element-90" data-mp="2m0vqyzpe76fn" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <CTAButton label="I want a professional teaching system" data-id="element-91" data-mp="1aouwd45uknrz" />
    </Section>;
}